import { validationDevice } from '../lib/tools';

const appInitialState = {
  devices: [],
  openUpdateDeviceDialog: false,
  currentDeviceId: 0,
  confirmData: {},
  confirmDataError: {
    deviceNickname: false,
  },
  refreshPage: false,
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'COMPANY_CHANGED': {
      return { ...appInitialState };
    }
    case 'SUCCESS_API_GET_DEVICES': {
      const { devices } = action.payload;
      return { ...state, devices };
    }
    case 'SUCCESS_API_GET_DEVICE_DETAIL': {
      const confirmData = action.payload;
      return { ...state, confirmData };
    }
    case 'OPEN_UPDATE_DEVICE_DIALOG': {
      const openUpdateDeviceDialog = true;
      const currentDeviceId =
        action.deviceId || appInitialState.currentDeviceId;
      return { ...state, openUpdateDeviceDialog, currentDeviceId };
    }
    case 'CLOSE_UPDATE_DEVICE_DIALOG': {
      const openUpdateDeviceDialog = false;
      const { currentDeviceId, confirmData, confirmDataError } =
        appInitialState;
      return {
        ...state,
        openUpdateDeviceDialog,
        currentDeviceId,
        confirmData,
        confirmDataError,
      };
    }
    case 'UPDATE_DEVICE_CONFIRM': {
      const { updateParam } = action;
      const checkResult = validationDevice(updateParam);
      const confirmData = { ...state.confirmData, ...updateParam };
      const confirmDataError = { ...state.confirmDataError, ...checkResult };
      return { ...state, confirmData, confirmDataError };
    }
    case 'SUCCESS_API_UPDATE_DEVICE': {
      return {
        ...state,
        refreshPage: !state.refreshPage,
      };
    }
    default:
      return state;
  }
};
